module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "header": false,
      "customClass": 'heightAuto',
      "footer": true
    }
  }, [_c('div', {
    staticClass: "p-4",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h2', {
    staticClass: "text-center mb-3"
  }, [_vm._v(_vm._s(("Duplicate - " + (_vm.itemRule.item.name))))]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("Please insert the new name:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row min-height"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duplicatedRule.name),
      expression: "duplicatedRule.name"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.duplicatedRule.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.duplicatedRule, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$v.duplicatedRule.name.$invalid) ? _c('div', {
    staticClass: "messages error"
  }, [(!_vm.$v.duplicatedRule.name.required) ? _c('span', [_vm._v("New name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.duplicatedRule.name.validCharacters) ? _c('span', [_vm._v("\n                        Invalid characters. Please use only letters, numbers, spaces, and the following special characters: "), _c('strong', [_vm._v(_vm._s(_vm.specialCharacters))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isInvalidName || _vm.isDuplicatingRule
    },
    on: {
      "click": _vm.pressDuplicate
    }
  }, [_vm._v("Duplicate")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ce64a1c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce64a1c6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/RulesDuplicate.vue
// module id = 2251
// module chunks = 0